import { useId } from 'react'
import { Info } from 'react-feather'
import { Badge, Card, CardBody, Col, Row, UncontrolledTooltip } from 'reactstrap'
import { getScoreBgColor, getScoreTextColor, getWorkingHoursBgColor, getWorkingHoursTextColor } from 'utility/Utils'
import MetricLabel from './MetricLabel'

const ComplianceCard = ({
  id,
  title,
  subtitle,
  tooltip,
  percentage,
  color,
  subcategories = [],
}) => {
  const uniqueId = useId().replace(/:/g, '')

  const getBgColor = (sub) => {
    if (sub.colorType === 'workingHours') return getWorkingHoursBgColor(sub.percentage)
    return getScoreBgColor(sub.percentage)
  }

  const getTxtColor = (sub) => {
    if (sub.colorType === 'workingHours') return getWorkingHoursTextColor(sub.percentage)
    return getScoreTextColor(sub.percentage)
  }

  return (
    <Card className="border-0 shadow-sm" data-testid={`findora-dashboard-compliance-card-${id}`}>
      <CardBody className="p-4">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h5 className="mb-1 fw-semibold d-flex align-items-center gap-1">
              {title}
              {tooltip && <><span id={`compliance-title-${uniqueId}`}><Info size={13} className="text-muted cursor-pointer" /></span><UncontrolledTooltip placement="top" target={`compliance-title-${uniqueId}`}>{tooltip}</UncontrolledTooltip></>}
            </h5>
            <p className="mb-0 text-muted small">{subtitle}</p>
          </div>
          <div className="text-end">
            <Badge
              color=""
              pill
              className="fs-6 fw-semibold px-3 py-2"
              style={{
                border: `1px solid ${getScoreTextColor(percentage)}20`,
                backgroundColor: getScoreBgColor(percentage),
                color: getScoreTextColor(percentage),
              }}
            >
              {percentage}%
            </Badge>
          </div>
        </div>

        {/* SUBCATEGORIES */}
        {subcategories.length > 0 && (
          <div className="mt-4">
            <Row className="g-3">
              {subcategories.map((sub, index) => (
                <Col xs="4" key={index} className="text-center">
                  <div
                    className={'bg-gray-50 p-3 text-center'}
                    style={{
                      minWidth: '100px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                    }}
                  >
                    <div className="d-flex flex-column align-items-center">
                      <div className="d-flex align-items-center justify-content-center gap-1 text-xs text-muted small text-center mb-1">
                        <span><MetricLabel label={sub.label} /></span>
                        {sub.tooltip && (
                          <>
                            <div
                              id={`compliance-info-${uniqueId}-${index}`}
                            >
                              <Info
                                size={12}
                                className="text-muted cursor-pointer"
                                style={{ flexShrink: 0 }}
                              />
                            </div>
                            <UncontrolledTooltip
                              placement="top"
                              target={`compliance-info-${uniqueId}-${index}`}
                            >
                              {sub.tooltip}
                            </UncontrolledTooltip>
                          </>
                        )}
                      </div>
                      <Badge
                        color=""
                        pill
                        className="px-3 py-2 text-sm"
                        style={{
                          backgroundColor: sub.percentage === 'N/A' ? '#f3f4f6' : getBgColor(sub),
                          color: sub.percentage === 'N/A' ? '#6b7280' : getTxtColor(sub),
                          border: `1px solid ${sub.percentage === 'N/A' ? '#e5e7eb' : `${getTxtColor(sub)}20`}`,
                        }}
                      >
                        {sub.percentage === 'N/A' ? 'N/A' : `${sub.percentage}${sub.suffix ?? '%'}`}
                      </Badge>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default ComplianceCard
